import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithImageNewPassword() {
	return <AuthShell variant="with-image"><AuthForm variant="with-image" mode="new-password" /></AuthShell>;
}

export default AuthWithImageNewPassword;
